import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useUrgentAction(code, defaultValue) {
  return useQuery({
    queryKey: ['urgentActions', code],
    queryFn: () => {
      if (code === 'new') {
        return defaultValue;
      }

      return briefingApi.get(`urgentActions/${code}`).json();
    },
    enabled: !!code,
  });
}
